import React from 'react';
import IconButton from 'material-ui/IconButton';
import TextField from 'material-ui/TextField';
import NumberFormat from 'react-number-format';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import {
    Grid,
    Icon,
} from '../../components';
import {
    eventoService,
    subeventoService,
    avaliadoresProjetoService,
    avaliadoresAreasService,
    areaService,
} from '../../services';
import PrincipalMaster from '../master/Principal';

class AcompanharAvaliadores extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dsEventos: [],
            dsSubeventos: [],
            dsAreas: [],
            eventoSelecionado: -1,
            subeventoSelecionado: 0,
            areaSelecionada: 0,
            dsAcompanharAvaliador: [],
            ano: '',
        };
    }
    async componentWillMount() {
        const anoAtual = new Date().getFullYear();
        const eventos = await eventoService.getEventosPeloAno(anoAtual);
        this.setState({
            ano: anoAtual,
            dsEventos: eventos,
        });
    }
    async buscarEventosPeloAno(ano) {
        const eventos = await eventoService.getEventosPeloAno(ano);
        this.setState({
            dsEventos: eventos,
            eventoSelecionado: 0,
            subeventoSelecionado: 0,
        });
    }

    async buscarSubEventosPeloEvento(evento) {
        const dadosSubevento = await subeventoService.getSubeventosDoEvento(evento);
        this.setState({ dsSubeventos: dadosSubevento, eventoSelecionado: evento });
    }

    async buscarAreasPeloSubEvento(subevento) {
        const areas = await areaService.getAreasCoordenador(subevento);
        this.setState({ dsAreas: areas, subeventoSelecionado: subevento });
    }

    async acompanharAvaliadores(area) {
        const { subeventoSelecionado } = this.state;

        const acompanharAvaliadores = await avaliadoresProjetoService.getAcompanharAvaliador(subeventoSelecionado, area);
        this.setState({ dsAcompanharAvaliador: acompanharAvaliadores, areaSelecionada: area });
    }

    async updateCheck(certificadoLiberado, isChecked, codigoAvaliador, index) {
        const { areaSelecionada, dsAcompanharAvaliador } = this.state;

        const liberado = (isChecked ? 1 : 0);
        await avaliadoresAreasService.update({ areaSelecionada, avaliador: codigoAvaliador, liberado });
        dsAcompanharAvaliador[index].CERTIFICADOLIBERADO = isChecked;
        this.setState({ dsAcompanharAvaliador });
    }

    render() {
        const {
            eventoSelecionado,
            subeventoSelecionado,
            areaSelecionada,
            dsSubeventos,
            dsEventos,
            dsAreas,
            dsAcompanharAvaliador,
            ano,
        } = this.state;

        return (
            <PrincipalMaster title="Projetos" {...this.props}>
                <div>
                    <form onSubmit={e => this.onSave(e)}>
                        <div className="padding-content">
                            <NumberFormat
                                format="####"
                                customInput={TextField}
                                required
                                value={ano}
                                errorText={ano ? '' : 'Campo obrigatório'}
                                floatingLabelText="Ano"
                                onBlur={() => this.buscarEventosPeloAno(ano)}
                                onChange={e => this.setState({ ano: e.target.value })}
                            />
                            <br />
                            <SelectField
                                floatingLabelText="Selecione um evento"
                                value={eventoSelecionado}
                                onChange={(_event, _index, value) => this.buscarSubEventosPeloEvento(value)}
                                errorText={eventoSelecionado > 0 ? '' : 'Campo obrigatório'}
                                fullWidth
                            >
                                {
                                    dsEventos.map(evento => (
                                        <MenuItem key={evento.CODIGO} value={evento.CODIGO} primaryText={evento.NOME} />
                                    ))
                                }
                            </SelectField>

                            <SelectField
                                floatingLabelText="Selecione um subevento"
                                value={subeventoSelecionado}
                                onChange={(_event, _index, value) => this.buscarAreasPeloSubEvento(value)}
                                fullWidth
                            >
                                <MenuItem value={0} primaryText="Todos" />
                                {
                                    dsSubeventos.map(subevento => (
                                        <MenuItem key={subevento.CODIGO} value={subevento.CODIGO} primaryText={subevento.NOME} />
                                    ))
                                }
                            </SelectField>

                            <SelectField
                                floatingLabelText="Selecione uma área"
                                value={areaSelecionada}
                                onChange={(_event, _index, value) => this.acompanharAvaliadores(value)}
                                errorText={areaSelecionada > 0 ? '' : 'Campo obrigatório'}
                                fullWidth
                            >
                                <MenuItem value={0} />
                                {
                                    dsAreas.map(area => (
                                        <MenuItem key={area.CODIGO} value={area.CODIGO} primaryText={area.NOME} />
                                    ))
                                }
                            </SelectField>
                        </div>
                    </form>
                </div>

                <div>
                    <div className="padding-content">
                        <Grid
                            onStyleRow={item => (
                                (item.avaliados * 100) / item.NumProjetos < 50 ?
                                    {
                                        backgroundColor: '#f11b1b0f',
                                    }
                                    :
                                    (item.avaliados * 100) / item.NumProjetos < 100 ?
                                        {
                                            backgroundColor: '#f5da311a',
                                        }
                                        :
                                        {
                                            backgroundColor: '#1fde601a',
                                        }
                            )}
                            ref={(ref) => { this.projetosGridRef = ref; }}
                            stripedRows="true"
                            textTableEmpty="Nenhum avaliador encontrado."
                            dataSource={dsAcompanharAvaliador}
							rowsPerPage="50"
                            columns={[
                                {
                                    text: 'Nome', name: 'NOME', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'E-mail', name: 'EMAIL', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Nº Projetos', name: 'NumProjetos', allowSort: true, allowSearch: true, searchOperator: 'LIKE', width: '100px',
                                },
                                {
                                    text: 'Avaliados', name: 'avaliados', allowSort: true, allowSearch: true, searchOperator: 'LIKE', width: '100px',
                                },
                                {
                                    text: 'Faltam', name: 'faltam', allowSort: true, allowSearch: true, searchOperator: 'LIKE', width: '100px',
                                },
                                {
                                    name: item => (
                                        <div>
                                            <a href={`/projetos-avaliador/${item.CODIGO}`} target="_blank" rel="noopener noreferrer">
                                                <IconButton>
                                                    <Icon name="visibility" />
                                                </IconButton>
                                            </a>
                                        </div>
                                    ),
                                },
                                {
                                    name: (item, index) => (
                                        <Checkbox
                                            checked={item.CERTIFICADOLIBERADO}
                                            onCheck={(event, isChecked) => this.updateCheck(item.CERTIFICADOLIBERADO, isChecked, item.CODIGO, index)}
                                        />
                                    ),
                                },
                            ]}
                        />
                    </div>

                </div>
            </PrincipalMaster>
        );
    }
}

export default AcompanharAvaliadores;
